<template>
    <div class="kpi-card" :class="`kpi-card--${size}`">
        <div v-if="label" class="kpi-label">{{ label }}</div>
        <div class="kpi-main">
            <span class="kpi-value" :style="valueStyle">{{ displayValue }}</span>
            <span v-if="delta" class="kpi-delta" :class="deltaClass">{{ delta }}</span>
        </div>
        <div v-if="hint" class="kpi-hint">{{ hint }}</div>
        <slot />
    </div>
</template>

<script>
export default {
    name: "KpiCard",
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            default: null,
        },
        delta: {
            type: [String, Number],
            default: null,
        },
        deltaUp: {
            type: Boolean,
            default: null,
        },
        hint: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
        },
    },
    computed: {
        displayValue(vm = this) {
            if (vm.value === null || vm.value === '') return vm.$t('common.without_data')
            return vm.value
        },
        valueStyle(vm = this) {
            return vm.color ? { color: vm.color } : null
        },
        isDeltaUp(vm = this) {
            if (typeof vm.deltaUp === 'boolean') return vm.deltaUp
            return !String(vm.delta).trim().startsWith('-')
        },
        deltaClass(vm = this) {
            return vm.isDeltaUp ? 'kpi-delta--up' : 'kpi-delta--down'
        },
    },
}
</script>

<style scoped>
.kpi-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 12px 14px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
}

.kpi-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--v-txtMuted-base);
}

.kpi-main {
    display: flex;
    align-items: baseline;
    gap: 6px;
    min-width: 0;
}

.kpi-value {
    font-weight: 700;
    line-height: 1.1;
    color: var(--v-txtPrimary-base);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.kpi-card--sm .kpi-value {
    font-size: 18px;
}

.kpi-card--md .kpi-value {
    font-size: 22px;
}

.kpi-card--lg .kpi-value {
    font-size: 26px;
}

.kpi-delta {
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
}

.kpi-delta--up {
    color: var(--v-success-base);
}

.kpi-delta--down {
    color: var(--v-error-base);
}

.kpi-hint {
    font-size: 11px;
    line-height: 1.3;
    color: var(--v-txtMuted-base);
}
</style>
